import { render, staticRenderFns } from "./PublishVersionModal.vue?vue&type=template&id=465a485d&scoped=true&"
import script from "./PublishVersionModal.vue?vue&type=script&lang=ts&"
export * from "./PublishVersionModal.vue?vue&type=script&lang=ts&"
import style0 from "./PublishVersionModal.vue?vue&type=style&index=0&id=465a485d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465a485d",
  null
  
)

export default component.exports